class BadRequestError extends Error {
  constructor() {
    super('Bad request');
  }
}

class UnauthorizedError extends Error {
  constructor() {
    super('Authorization failure');
  }
}

class UnknownResponseError extends Error {
  constructor() {
    super('Unable to process response');
  }
}

class BadGatewayError extends Error {
  constructor() {
    super('Unable to contact backend service');
  }
}

class PermissionDeniedError extends Error {
  constructor() {
    super('Permission denied');
  }
}

function checkStatus(response) {
  if (response.ok) {
    return;
  }

  switch (response.status) {
    case 400:
      throw new BadRequestError();
    case 401:
      throw new UnauthorizedError();
    case 403:
      throw new PermissionDeniedError();
    case 502:
      throw new BadGatewayError();
    default:
      throw Error(response.statusText);
  }
}

export {
  UnknownResponseError,
  UnauthorizedError,
  PermissionDeniedError,
  checkStatus,
};
